/** @format */

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideChildService, toggleRender } from "../../../store/stateSlice";
import Popup from "../../global/form create/Popup";
import UploadPhoto from "../../inputs/UploadPhoto";
import InputSelect from "../../inputs/InputSelect";
import InputField from "../../inputs/inputField";
import InputTextarea from "../../inputs/inputTextarea";
import { alertMsg } from "../../../utilities/helper";
import { Spinner1 } from "../../spinners/Spinner1";
import {
  postService,
  setEdit,
  setServiceCatIDS,
  updateServiceAttr,
} from "../../../store/service";
import { getOne } from "../../../store/helper";
import { renderCategory } from "../../../store/category";
import { imgUrl } from "../../../store/api";
import { Checkbox, Col, Row } from "antd";
import InputCheckBox from "../../inputs/inputCheckbox";
import axios from "axios";

const initState = {
  photo: null,
  viewPhoto: "",
  users: [],
  en_name: "",
  ar_name: "",
  desc_en: "",
  desc_ar: "",
  cond_en: "",
  cond_ar: "",
  price: "",
  service_status: "",
};
const attributes = [
  { title: "from", value: 0, attr_name: "from" },
  { title: "to", value: 0, attr_name: "to" },
  { title: "Appointment Date", value: 0, attr_name: "appointment_date" },
  { title: "Appointment Time", value: 0, attr_name: "appointment_time" },
  { title: "Gender", value: 0, attr_name: "gender" },
  { title: "Embassy", value: 0, attr_name: "embassy" },
  { title: "Select Service", value: 0, attr_name: "select_service" },
  { title: "Employee Status", value: 0, attr_name: "employee_status" },
  { title: "Image Front", value: 0, attr_name: "image_front" },
  { title: "Image Back", value: 0, attr_name: "image_back" },
  { title: "Image Ticket", value: 0, attr_name: "image_ticket" },
  { title: "Image Passport", value: 0, attr_name: "image_passport" },
  { title: "Image Visa", value: 0, attr_name: "image_visa" },
  { title: "Image Office", value: 0, attr_name: "image_office" },
  { title: "Contact Details", value: 0, attr_name: "contact_details" },
  { title: "Nationality", value: 0, attr_name: "nationality" },
  { title: "Type Ticket", value: 0, attr_name: "type_ticket" },
  { title: "Employee Name", value: 0, attr_name: "employee_name" },
  { title: "Number Passport", value: 0, attr_name: "number_passport" },
  { title: "Country Passport", value: 0, attr_name: "country_passport" },
  { title: "Phone Number", value: 0, attr_name: "phone_number" },
];
const ChildNewServices = () => {
  const [attr, setAttr] = useState(attributes);
  //view popup when onclick "اضافه خدمة جديدة"
  const viewPopup = useSelector(
    (state) => state.toggleState.value.childNewService
  );

  //redux
  const dispatch = useDispatch();
  const serviceStore = useSelector((state) => state.service);
  const hidePupup = () => {
    dispatch(hideChildService());
    setAttr(attributes);
  };

  // handel data form
  const [values, setValues] = useState(initState);
  const [state, setState] = useState("");

  // State to store uploaded file
  const [file, setFile] = React.useState("");

  useEffect(() => {
    if (serviceStore.serviceID) {
      dispatch(
        getOne({
          path: "/service-attributes/",
          id: serviceStore.serviceID,
        })
      ).then((res) => {
        if (res.payload?.data?.length > 0)
          setAttr(
            attr.map((item) => ({
              ...item,
              value: res.payload.data[0][item.attr_name],
            }))
          );
      });

      dispatch(
        getOne({
          path: "/services/",
          id: serviceStore.serviceID,
        })
      )
        .unwrap()
        .then((res) => {
          const {
            name_en,
            name_ar,
            image,
            status,
            price,
            description_en,
            description_ar,
            terms_conditions_en,
            terms_conditions_ar,
          } = res.data;

          setValues({
            ...values,
            en_name: name_en,
            ar_name: name_ar,
            photo: image,
            service_status: status,
            price,
            desc_en: description_en,
            desc_ar: description_ar,
            cond_en: terms_conditions_en,
            cond_ar: terms_conditions_ar,
          });
          setState(status);
          dispatch(setEdit({ edit: false }));
        });
    } else if (serviceStore.edit === false) {
      setValues(initState);
    }
  }, [serviceStore.serviceID]);

  // Handles file upload event and updates state
  function handleUpload(e) {
    const file = e.target.files[0];
    setFile(file);
  }

  const handleChange = ({ target }) => {
    setValues({
      ...values,
      [target.name]: target.value,
      service_status: state,
      photo: file,
    });
  };

  // fires on submit form
  const handleSubmit = (e) => {
    e.preventDefault();
    let valuesClone = { ...values };
    if (file) {
      setValues({ ...values, photo: file });
      valuesClone = { ...valuesClone, photo: file };
    }

    if (
      !values.photo ||
      !values.ar_name ||
      !values.en_name ||
      !values.desc_ar ||
      !values.desc_en ||
      !values.price ||
      !values.cond_ar ||
      !values.cond_en ||
      !values.service_status
    ) {
      alertMsg("جميع البيانات مطلوبة", false);
    } else {
      if (serviceStore.serviceID) {
        valuesClone = {
          ...valuesClone,
          categoryID: serviceStore.categoryID,
          serviceID: serviceStore.serviceID,
          method: "PUT",
        };
        dispatch(postService(valuesClone)).then((res) => {
          if (res.payload.status === 200) {
            dispatch(toggleRender());
            dispatch(setServiceCatIDS({ serviceID: null, categoryID: null }));
            dispatch(hideChildService());
          }
        });
        const AttrBody = attr.reduce((acc, item) => {
          const key = item.attr_name;

          return { ...acc, [key]: item.value };
        }, {});

        dispatch(
          updateServiceAttr({
            serviceID: serviceStore.serviceID,
            data: AttrBody,
          })
        );
      }
      if (!serviceStore.serviceID) {
        valuesClone = {
          ...valuesClone,
          categoryID: serviceStore.categoryID,
          method: "POST",
        };
        dispatch(postService(valuesClone)).then((res) => {
          if (res.payload.status === 200) {
            dispatch(toggleRender());
            dispatch(setServiceCatIDS({ serviceID: null, categoryID: null }));
            dispatch(hideChildService());
          }
        });
      }

      setValues(valuesClone);
    }
  };
  console.log("attr", attr);

  return (
    <>
      {serviceStore.loading && <Spinner1 />}
      <Popup viewPupup={viewPopup} hidePupup={hidePupup} viewWidth="content-xl">
        <form className="main-contnt" onSubmit={handleSubmit}>
          <div className="head-content">
            <UploadPhoto
              name="ChildNewServices"
              handleUpload={handleUpload}
              file={file}
              value={values.photo}
              image={values.photo}
            />
          </div>

          <div className="body-content">
            <InputSelect
              value={state}
              name="cat_status"
              label="حالة الخدمة"
              onChange={setState}
              options={[
                { label: "نشطة", value: "active" },
                { label: "غير نشطة ", value: "inactive" },
              ]}
              placeholder="اختر حالة المجموعة"
              note="*"
            />
            <InputField
              value={values.ar_name}
              title="اسم الخدمة باللغة العربية"
              placeholder="اكتب اسم الخدمة"
              note="*"
              required={true}
              onChange={handleChange}
              name="ar_name"
            />
            <InputField
              value={values.en_name}
              title="  اسم الخدمة باللغة الانجليزية"
              placeholder="اكتب اسم الخدمة"
              note="*"
              required={true}
              onChange={handleChange}
              name="en_name"
            />
            <InputField
              type="number"
              pattern="[0-9]*"
              value={values.price}
              title="سعر الخدمة"
              placeholder="اكتب سعر الخدمة"
              note="*"
              required={true}
              onChange={handleChange}
              name="price"
            />
            <InputTextarea
              value={values.desc_ar}
              title="وصف الخدمة باللغة العربية"
              placeholder="اكتب شروط و احكام الخدمة"
              required={true}
              onChange={handleChange}
              name="desc_ar"
              note="*"
            />
            <InputTextarea
              value={values.desc_en}
              title="وصف الخدمة باللغة الانجليزية "
              placeholder="اكتب شروط و احكام الخدمة"
              required={true}
              onChange={handleChange}
              name="desc_en"
              note="*"
            />
            <InputTextarea
              value={values.cond_ar}
              title=" الشروط والاحكام باللغة العربية "
              placeholder="اكتب شروط و احكام الخدمة"
              required={true}
              onChange={handleChange}
              name="cond_ar"
              note="*"
            />
            <InputTextarea
              value={values.cond_en}
              title=" الشروط والاحكام باللغة الانجليزية "
              placeholder="اكتب شروط و احكام الخدمة"
              required={true}
              onChange={handleChange}
              name="cond_en"
              note="*"
            />
            {serviceStore.serviceID && (
              <CheckboxGroup values={attr} setValues={setAttr} />
            )}
          </div>
          <div className="buttons-contnt center-flex">
            <input type="submit" value="اضافه" class="btn btn__primary" />
            <div class="btn btn__danger" onClick={hidePupup}>
              الغاء
            </div>
          </div>
        </form>
      </Popup>
    </>
  );
};

export default ChildNewServices;

const CheckboxGroup = ({ values, setValues }) => {
  const onChange = ({ target }) => {
    setValues(
      values.map((item) =>
        item.attr_name === target.name
          ? { ...item, value: +target.value === 1 ? 0 : 1 }
          : item
      )
    );
  };

  return (
    <form
      style={{
        width: "100%",
      }}
      onChange={onChange}
    >
      <Row>
        {values.map((item, index) => {
          return (
            <Col span={8} name={item.attr_name} key={item.attr_name}>
              <div className="flex row-flex">
                <input
                  type="checkbox"
                  checked={+item.value === 1 ? true : false}
                  id={item.attr_name}
                  name={item.attr_name}
                  value={item.value}
                />
                <label for={item.attr_name}>{item.title}</label>
              </div>
            </Col>
          );
        })}
      </Row>
    </form>
  );
};
